<ng-container *transloco="let t; read: 'info-snackbar'">
  <div class="flex-row gap-1 align-center">
    <app-value value="Info" [bgFill]="true" [info]="true"></app-value>
    <span>{{ data.message }}</span>
    <button mat-button (click)="dismiss()" color="accent">{{ t('Dismiss') }}</button>
  </div>
</ng-container>
